import BeCuponUtils from "@/utils/Utils";

export default class MetaSeller {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        metaSellerRetrieve(id: ${id}) {
          id
          status
          current
          paid
          datetime
          seller {
            id
            type
            user {
              id
              firstName
              lastName
              email
              profile {
                image {
                  url
                }
              }         
            }
          }
          meta {
            id
            name
            type
          }         
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );   

    response.data.data.metaSellerRetrieve.compressed = {
      seller: response.data.data.metaSellerRetrieve.seller,
      meta: response.data.data.metaSellerRetrieve.meta
    };

    if(response.data.data.metaSellerRetrieve.datetime !== null) {
       response.data.data.metaSellerRetrieve.date = response.data.data.metaSellerRetrieve.datetime.split('T')[0];
       response.data.data.metaSellerRetrieve.time = response.data.data.metaSellerRetrieve.datetime.split('T')[1].substr(0,5);       
    }
    else {
       response.data.data.metaSellerRetrieve.date = null;
       response.data.data.metaSellerRetrieve.time = null;       
    }

    response.data.data.metaSellerRetrieve.seller = response.data.data.metaSellerRetrieve.seller.id;
    response.data.data.metaSellerRetrieve.meta = response.data.data.metaSellerRetrieve.meta.id;

    return response.data.data.metaSellerRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        metaSellerList {
          results {
            id
            status
            current
            paid
            datetime
            seller {
              id
              type
              user {
                id
                email
                profile {
                  image {
                    url
                  }
                }         
              }
            }
            meta {
              id
              name
              type
            }                    
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    
    for(var i = 0; i < response.data.data.metaSellerList.results.length; i++) {
      response.data.data.metaSellerList.results[i].status = response.data.data.metaSellerList.results[i].status  === 'A' ? 'ALCANZADO' : 'NO ALCANZADO';
      response.data.data.metaSellerList.results[i].datetime = BeCuponUtils.formatDateTime(response.data.data.metaSellerList.results[i].datetime);
      response.data.data.metaSellerList.results[i].paid = response.data.data.metaSellerList.results[i].paid ? 'SI' : 'NO'; 
    }
    /*for(var i = 0; i < response.data.data.metaList.results.length; i++)
    {
      switch(response.data.data.metaList.results[i].type) {
        case "D":
           response.data.data.metaList.results[i].type = "DESCARGA";
        break;
        case "C":
           response.data.data.metaList.results[i].type = "CIERRE DE DEAL";
        break;   
        case "R":
           response.data.data.metaList.results[i].type = "REGISTRO";
        break;
        case "V":
           response.data.data.metaList.results[i].type = "VENTA DE CUPONERA";
        break;                      
      }
    }*/

    return response.data.data.metaSellerList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteMetaSeller(id: ${id}) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteMetaSeller.ok;
  }

}